import React from 'react'
import { useDispatch } from 'react-redux'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

import CollectionCard from 'components/Card/CollectionCard'

// styles
import styles from './index.module.scss'

// apis
import collectionAPI from 'apis/collections'

const CollectionSwiperSection = props => {
  const { collections, isOwn, showFilter } = props
  const dispatch = useDispatch()

  const removeCollection = collectionId => {
    collectionAPI.deleteCollection(collectionId).then(
      response => {
        dispatch({ type: 'set', removeCollectionId: collectionId })
      },
      error => {}
    )
  }

  return collections.length === 0 ? (
    <section className={styles.container}>
      <div className={styles.noData}>No collections available</div>
    </section>
  ) : (
    <section className={styles.container}>
      <div className="w-full">
        <div
          className={`w-full grid sm:grid-cols-2 ${
            showFilter ? 'lg:grid-cols-2 2xl:grid-cols-3' : 'lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4'
          } gap-[20px] lg:gap-[10px] xl:gap-[15px] z-10 pb-[30px]`}
        >
          {collections.map((item, index) => (
            <div key={index}>
              <CollectionCard
                image={item.cover_image}
                nftName={item.collection_name}
                artistName={item.artist_username}
                collectionId={item.collection_id}
                unSave={() => removeCollection(item.collection_id)}
                isOwn={isOwn}
              />
              {/* <TrendingCollectionCard
                collectionID={item.collection_id}
                image={item.cover_image}
                collectionName={item.collection_name}
                artistName={item.artist_username}
                nftCount={item.number_in_collections}
                avatar={item.artist_profile_picture}
                key={index}
                showRemoveButton={showRemoveButton}
              /> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CollectionSwiperSection
